export const STATUS = {
  vrij: { color: "#10B981", bg: "#ECFDF5", nl: "Vrij", es: "Libre", en: "Free" },
  bezet: { color: "#F43F5E", bg: "#FFF1F2", nl: "Bezet", es: "Ocupado", en: "Occupied" },
  gereserveerd: { color: "#F59E0B", bg: "#FFFBEB", nl: "Gereserveerd", es: "Reservado", en: "Reserved" },
  buiten_dienst: { color: "#64748B", bg: "#F1F5F9", nl: "Buiten dienst", es: "Fuera de servicio", en: "Out of service" },
};

export const STATUS_ORDER = ["vrij", "bezet", "gereserveerd", "buiten_dienst"];

export const FLAGS = {
  controle_nodig: { color: "#8B5CF6", nl: "Controle nodig", es: "Requiere control", en: "Check needed" },
  rood_lintje: { color: "#E11D48", nl: "Rood lintje", es: "Cinta roja", en: "Red ribbon" },
};

export const GUEST_LANGUAGES = [
  { code: "bg", label: "Български" },
  { code: "cs", label: "Čeština" },
  { code: "da", label: "Dansk" },
  { code: "de", label: "Deutsch" },
  { code: "el", label: "Ελληνικά" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "et", label: "Eesti" },
  { code: "fi", label: "Suomi" },
  { code: "fr", label: "Français" },
  { code: "ga", label: "Gaeilge" },
  { code: "hr", label: "Hrvatski" },
  { code: "hu", label: "Magyar" },
  { code: "it", label: "Italiano" },
  { code: "lt", label: "Lietuvių" },
  { code: "lv", label: "Latviešu" },
  { code: "mt", label: "Malti" },
  { code: "nl", label: "Nederlands" },
  { code: "no", label: "Norsk" },
  { code: "pl", label: "Polski" },
  { code: "pt", label: "Português" },
  { code: "ro", label: "Română" },
  { code: "sk", label: "Slovenčina" },
  { code: "sl", label: "Slovenščina" },
  { code: "sv", label: "Svenska" },
];

// De taal waarin een gast zijn documenten en mails krijgt: alle EU-talen.
export const LANGUAGES = GUEST_LANGUAGES;

// Naam van een taal in de taal van de gebruiker, bv. "es" wordt "Spaans" in het Nederlands
export const langName = (code, uiLang = "nl") => {
  try {
    const name = new Intl.DisplayNames([uiLang], { type: "language" }).of(code);
    if (name && name.toLowerCase() !== code.toLowerCase()) return name.charAt(0).toUpperCase() + name.slice(1);
  } catch (e) { /* zonder Intl-ondersteuning valt het terug op de eigen naam */ }
  return GUEST_LANGUAGES.find((l) => l.code === code)?.label || code;
};

export const money = (v, cur = "EUR") =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: cur }).format(Number(v) || 0);

export const fmtDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};
